import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
 
} from "reactstrap";
import toast from 'react-hot-toast';
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import Select from "react-select";

//redux
import Spinners from "components/Common/Spinner";
import {  deleteEvent, deleteUser, getAllCountries, getAllEventByOrganizer, getAllEvents, getAllOrganizer, getEventByCountryId, getEventByQuery, updateUser,updateEvent  } from "api";
import { handleError } from "utils/errorHandler";
import moment from "moment";
import { getAuthUser, getCountryId, getUserRole } from "utils/storage";

const EventList = () => {

  const navigate = useNavigate();

  //meta title
  document.title = "EventList List | EventoX";

  const [eventList, setEventList] = useState([])
  const [organizerList, setOrganizerList] = useState([])
  const [selectedOrganizer, setSelectedOrganizer] = useState(null)
  const [contact, setContact] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [event, setEvent] = useState([])
  const [TinyUrl, setTinyUrl] = useState(false);
  const [tinyModal, setTinyModal] = useState(false);
  const [sponsorModal, setSponsorModal] = useState(false);
const [selectedEventForSponsor, setSelectedEventForSponsor] = useState(null);
const [selectedThumbImg, setSelectedThumbImg] = useState(null)
const [sponsorName, setSponsorName] = useState("");
const [websiteUrl, setWebsiteUrl] = useState("");
const [errors, setErrors] = useState({});
const [selectedBannerImgDesktop, setSelectedBannerImgDesktop] = useState(null);
const [selectedBannerImgMobile, setSelectedBannerImgMobile] = useState(null);
const [selectedEvent,setSelectedEvent]=useState([null])
const [eventOptions, setEventOptions] = useState([]);







  useEffect(() => {
    
    fetchAll();
    return () => {

    }
  }, [])

  const fetchAll=async()=>{
    try {
      const role = getUserRole();
      const countryId = getCountryId();
      let respAllEvent = [];
      if (role === 1) {
        respAllEvent = await getAllEvents();
      } else {
        respAllEvent = await getEventByCountryId(countryId);
      }
    
      // Create event options for Select component
      const eventOptionsData = (respAllEvent || []).map(event => ({
        value: event.slugId,
        label: event.eventName
      }));
      
      // Set event list with FULL event data
      setEventList(respAllEvent);
      setEventOptions(eventOptionsData);
      let orgRes = await getAllOrganizer();
      const resOrganizerOptions = orgRes.map((item) => {
        return {
          value: item.organizerId,
          label: item.name,
          
        }})

      setOrganizerList([{
        label: "All",
        value: "all"
      },...resOrganizerOptions,])
      
    } catch (error) {
      console.log(error);
    }
    
  }
  const toggle = () => setTinyModal(!tinyModal);
  const fetchEventByOrganizer = async (organizerId) => {
    try {
      if(organizerId === "all"){
        const role = getUserRole();
        const countryId = getCountryId();
        let resp = [];
        if (role === 1) {
          resp = await getAllEvents();
        } else {
          resp = await getEventByCountryId(countryId);
        }
        setEventList(resp)
      }else{
      const resp = await getEventByQuery("organizerId",organizerId);
      setEventList(resp)
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  const viewEvent = (eventData) => {
    navigate(`/event-detail/${eventData.eventId}`);
  };
  // const handleClickedAddSponsor = (eventData) => {
  
  // }
  const toggleSponsorModal = () => setSponsorModal(!sponsorModal);

const handleClickedAddSponsor = (eventData) => {
  setSelectedEventForSponsor(eventData);
  toggleSponsorModal();
};
const handleImageChange = (event, filed) => {
  if (event.target.files[0].size > 2097152) {
    toast.error("File size should be less than 2MB");
  } else {
    event.preventDefault();
    let reader = new FileReader();
    let file = event.target.files[0];
    reader.onloadend = () => {
      if (filed === 'thumbImg') setSelectedThumbImg(reader.result);
      if (filed === 'bannerImgDesktop') setSelectedBannerImgDesktop(reader.result);
      if (filed === 'bannerImgMobile') setSelectedBannerImgMobile(reader.result);
      // setSelectedImage(reader.result);
      // validation.setFieldValue(filed, file)
    };
    reader.readAsDataURL(file);
  }
};

  
const handleClickedTinyUrl = (eventData) => {
  // Use the backend tinyUrl
  const shortUrl = `https://eventox.co/tiny/${eventData.tinyUrl}`;

setSelectedEvent({ ...eventData, shortUrl });
toggle(); // Show modal with the short URL

};
const copyToClipboard = (url) => {
  navigator.clipboard.writeText(url)
    .then(() => {
      toast.success("URL copied to clipboard!");  // Optional: feedback to the user
    })
    .catch((error) => {
      toast.error("Failed to copy URL: " + error);

    });
};
const validateSponsorForm = () => {
  let errors = {};

  if (!sponsorName.trim()) {
    errors.sponsorName = "Sponsor name is required";
  }

  const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/;
  if (!websiteUrl.trim()) {
    errors.websiteUrl = "Website URL is required";
  } else if (!urlPattern.test(websiteUrl)) {
    errors.websiteUrl = "Enter a valid URL";
  }

  setErrors(errors);
  return Object.keys(errors).length === 0;
};

const handleSaveSponsor = () => {
  if (validateSponsorForm()) {
    // Proceed with saving sponsor
    toast.success("Sponsor added successfully!");
    toggleSponsorModal();
  } else {
    toast.error("Please fix the errors before saving.");
  }
};
const handleToggleFeatured = React.useCallback(async (eventData) => {
  try {
    const updatedValue = !eventData.isFeatured; 
    console.log("Toggling", eventData.eventId, "to", updatedValue);
    
    setEventList(prev =>
      prev.map(ev =>
        ev.eventId === eventData.eventId
          ? { ...ev, isFeatured: updatedValue }
          : ev
      )
    );

    await updateEvent(eventData.eventId, { isFeatured: updatedValue });
    
    toast.success(`Featured ${updatedValue ? "enabled" : "disabled"}`);
  } catch (error) {
    console.error("Toggle error:", error);
    toast.error("Failed to update featured status");
    handleError(error);
  }
}, []);

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "thumbImg",
        cell: (cell) => (
          <>
            {!cell.getValue() ? (
              <div className="avatar-xs">
                <span className="avatar-title rounded-circle">{cell.row.original.eventName.charAt(0)} </span>
              </div>
            ) : (
              <div>
                <img className="rounded-circle avatar-xs" src={cell.getValue()} alt="" />
              </div>
            )}
          </>
        ),
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Event Name',
        accessorKey: 'eventName',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                <Link to='#' className='text-dark'>{cell.getValue()?.length > 20 ? cell.getValue().substring(0, 20) + "..." : cell.getValue()}</Link>
              </h5>
              <p className="text-muted mb-0">
                {`${cell.row.original.eventVenue}, ${cell.row.original?.Country?.countryName}`?.length > 25 ? `${cell.row.original.eventVenue}, ${cell.row.original?.Country?.countryName}`.substring(0, 25) + "..." : `${cell.row.original.eventVenue}, ${cell.row.original?.Country?.countryName}`}
              </p>
              <p className="text-muted mb-0">{moment(cell.row.original.eventDate).format('MMMM DD, yy')}</p>
            </>
          )
        }
      },
      
      {
        header: 'Organizer',
        accessorKey: 'Organizer.name',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          const name = cell.getValue();
          return <span>{name?.length > 20 ? name.substring(0, 20) + "..." : name}</span>
        }
      },
      {
        header: 'Date',
        accessorKey: 'eventDate',
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: 'Category',
      //   accessorKey: 'Category.categoryName',
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      // {
      //   header: 'Ticket Type',
      //   accessorKey: 'ticketType',
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      // {
      //   header: 'Event Type',
      //   accessorKey: 'eventType',
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
     
      {
        header: 'Status',
        accessorKey: 'eventStatus',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <div>
              {

                <span className="badge badge-soft-primary font-size-11 m-1">{cell.getValue()}</span>

              }
            </div>
          );
        },
      },
      {
        header: "Featured",
        accessorKey: "isFeatured",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const eventData = row.original;
          return (
            <button
              className={`btn btn-sm rounded-pill px-3 ${
                eventData.isFeatured 
                  ? 'btn-primary text-white'  
                  : 'btn-outline-primary'
              }`}
              onClick={() => handleToggleFeatured(eventData)}
              style={{ minWidth: '80px', fontSize: '12px' }}
            >
              {eventData.isFeatured ? 'True' : 'False'}
            </button>
          );
        },
      },
      
      {
        header: 'Tiny Url',
        accessorKey: 'tinyUrl',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const eventData = row.original;
          const url = `https://eventox.co/tiny/${eventData.tinyUrl}`;
      
          return (
            <div className="d-flex align-items-center gap-2">
              <span>{url}</span>
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => copyToClipboard(url)}
              >
               copy
              </button>
            </div>
          );
        }
      },
      
      {
        header: 'Action',
        cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                {/* <DropdownItem
                  onClick={() => {
                    const customerData = cellProps.row.original;
                    handleCustomerClick(customerData);
                  }
                  }
                >
                  <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem> */}
                {/* {cellProps.row.original.ticketType === "paid"&&cellProps.row.original.paymentChannel === "our" && (
                <DropdownItem
                  onClick={() => {
                    const customerData = cellProps.row.original;
                    handleTicketClick(customerData);
                  }
                  }
                >
                  <i className="mdi mdi-plus font-size-16 text-success me-1" id="edittooltip"></i>
                  Add Ticket Details
                  <UncontrolledTooltip placement="top" target="edittooltip">
                  Add Ticket Details
                  </UncontrolledTooltip>
                </DropdownItem>
              )} */}
                {/* <DropdownItem
                  onClick={() => {
                    const customerData = cellProps.row.original;
                    onClickDelete(customerData);
                  }}>
                  <i className="mdi mdi-trash-can font-size-16 text-danger me-1" id="deletetooltip"></i>
                  Delete
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </DropdownItem> */}
                <DropdownItem
                  onClick={() => {
                    const customerData = cellProps.row.original;
                    handleEditEvent(customerData);
                  }}>
                  <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    const data = cellProps.row.original;
                    viewEvent(data);
                  }
                  }
                >
                  <i className="mdi mdi-eye font-size-16 text-success me-1" id="edittooltip"></i>
                  View Details
                  <UncontrolledTooltip placement="top" target="edittooltip">
                  View Details
                  </UncontrolledTooltip>
                </DropdownItem>
                {/* <DropdownItem
                  onClick={() => {
                    const customerData = cellProps.row.original;
                    handleCustomerClick(customerData);
                  }
                  }
                >
                  <i className="mdi mdi-plus font-size-16 text-success me-1" id="edittooltip"></i>
                  Add Additional Details
                  <UncontrolledTooltip placement="top" target="edittooltip">
                  Add Additional Details
                  </UncontrolledTooltip>
                </DropdownItem> */}
                {/* <DropdownItem
                  onClick={() => {
                    const eventData = cellProps.row.original;
                    handleClickedTinyUrl(eventData);
                  }
                  }
                >
                  <i className="mdi mdi-web font-size-16 text-success me-1" id="edittooltip"></i>
                 Tiny url
                  <UncontrolledTooltip placement="top" target="edittooltip">
                  Tiny url
                  </UncontrolledTooltip>
                </DropdownItem> */}
                <DropdownItem
  onClick={() => {
    const eventData = cellProps.row.original;
    handleClickedAddSponsor(eventData);
  }}
>
  <i className="mdi mdi-plus font-size-16 text-success me-1" id="edittooltip"></i>
  Add Sponsor
  <UncontrolledTooltip placement="top" target="edittooltip">
    Add Sponsor
  </UncontrolledTooltip>
</DropdownItem>
<DropdownItem
                  onClick={() => {
                    const customerData = cellProps.row.original;
                    onClickDelete(customerData);
                  }}>
                  <i className="mdi mdi-trash-can font-size-16 text-danger me-1" id="deletetooltip"></i>
                  Delete
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </DropdownItem>

              </DropdownMenu>
            </UncontrolledDropdown>
          );
        }
      },
    ],
    []
  );
  const handleClickNewEvent = () => {
    navigate("/event/newquick")
  }

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (eventData) => {
    setEvent(eventData);
    setDeleteModal(true);
  };
  const handleEditEvent = (eventData) => {
    navigate("/admin/events/edit/" + eventData.eventId)
  }


  const handleDeleteEvent = async() => {
    if (event && event.eventId) {
      try {
      
       const resp = await deleteEvent(event.eventId);
       toast.success("Delete event successfully");
       fetchAll()
      } catch (error) {
        toast.error("Error Deleting event " + error?.message);
        handleError(error)
      }

    }
    setDeleteModal(false);
  };
  
  const handleCustomerClick = (customerData) => {
    console.log("Customer clicked:", customerData);
    navigate(`/customer/${customerData.customerId}`);
  };
  
  // const handleClickedEdit = (data) => {
    
  //   toggle();
  // }
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Events List" />

          <Row>
            {
              isLoading ? <Spinners setLoading={setIsLoading} />
                :
                <Col lg="12">

                  <Card>
                    <CardBody>
                      <Row className="mb-3">
                        <Col xl="5">
                          <div className="col-md-12">
                            <Select
                              value={selectedOrganizer}
                              placeholder="Select Organizer"
                              onChange={(data) => {
                                fetchEventByOrganizer(data.value)
                                setSelectedOrganizer(data)
                              }}
                              options={organizerList}
                              width="100%"
                              className="select2-selection"
                            />

                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <TableContainer
                          columns={columns}
                          data={eventList || []}
                          isGlobalFilter={true}
                          isPagination={true}
                          SearchPlaceholder="Search..."
                          isCustomPageSize={true}
                          isAddButton={true}
                          handleUserClick={handleClickNewEvent}
                          buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                          buttonName="New Event"
                          tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                          theadClass="table-light"
                          paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                          pagination="pagination"
                        />
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
            }
 <Modal isOpen={tinyModal} toggle={toggle}>
              <ModalHeader toggle={toggle} tag="h4">
                {!!TinyUrl ? "Tiny Url" : ""}
              </ModalHeader>
              <ModalBody>
                <Form
                  // onSubmit={e => {
                  //   e.preventDefault();
                  //   validation.handleSubmit();
                  //   return false;
                  // }}
                >
                  <Row>
                  <Col xs={12}>
                  <div className="mb-3">
                  <Label className="form-label">Event Name</Label>
                  <Input
                          name="eventName"
                          type="text"
                          value={selectedEvent.eventName ||""}
                         readOnly
                        />
                  </div>
                  
                  <div className="mb-3">
  <Label className="form-label">Tiny URL</Label>
  <div className="d-flex align-items-center">
    <Input
      name="tinyUrl"
      type="text"
      value={selectedEvent.shortUrl || ""}
      readOnly
    />
    <button type="button" onClick={() => copyToClipboard(selectedEvent.shortUrl)}className="btn btn-link ms-2">copy</button>
  </div>
</div>
                  
                  </Col>
                  </Row>
                </Form>
                </ModalBody>
                </Modal>
                <Modal isOpen={sponsorModal} toggle={toggleSponsorModal}>
  <ModalHeader toggle={toggleSponsorModal} tag="h4">Add Sponsor</ModalHeader>
  <ModalBody>
    <Form>
      <Row>
        <Col xs={12}>
        <div className="mb-3">
          <Select
  value={selectedEvent}
  options={eventOptions}
  onChange={(selectedOption) => setSelectedEvent(selectedOption)}
  placeholder="Select Event"
 width="100%"
 className="select2-selection"
 styles={{
   menu: provided => ({ ...provided, zIndex: 9999 })
 }}
 
 
/>
</div>
          <div className="mb-3">
         
            <Label className="form-label">Sponsor Name</Label>
            <Input
              name="sponsorName"
              type="text"
              placeholder="Enter Sponsor Name"
              value={sponsorName}
              onChange={(e) => setSponsorName(e.target.value)}
              invalid={!!errors.sponsorName}
            />
            {errors.sponsorName && <FormFeedback>{errors.sponsorName}</FormFeedback>}
          </div>

          <div className="mb-3">
            <Label className="form-label">Website URL</Label>
            <Input
              name="WebsiteUrl"
              type="text"
              placeholder="Enter URL"
              value={websiteUrl}
              onChange={(e) => setWebsiteUrl(e.target.value)}
              invalid={!!errors.websiteUrl}
            />
            {errors.websiteUrl && <FormFeedback>{errors.websiteUrl}</FormFeedback>}
          </div>

          <div className="mb-3">
            <Label className="form-label">Thumbnail Image</Label>
            <p className="text-muted">The Image should be min 561 × 691 pixels</p>
            <div className="position-relative d-inline-block">
              <Label htmlFor="project-image-input1" className="mb-0" id="projectImageInput">
                <div className="avatar-xs">
                  <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                    <i className="bx bxs-image-alt"></i>
                  </div>
                </div>
              </Label>
              <input className="form-control d-none" id="project-image-input1" type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'thumbImg')} />
            </div>
            {selectedThumbImg && (
              <div className="avatar-lg upload-image-container">
                <img src={selectedThumbImg} alt="Thumbnail" className="avatar-md h-auto" />
              </div>
            )}
          </div>
          
        </Col>
      </Row>

      <div className="text-end">
        <button type="button" className="btn btn-primary" onClick={handleSaveSponsor}>
          Save
        </button>
      </div>
    </Form>
  </ModalBody>
</Modal>

          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withRouter(EventList);